interface Texts {
  TITLE: string
}

const Texts: Texts = {
  'TITLE': 'Dúvidas',
}

export default Texts
